// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function(it){
  return Object(defined(it));
};


//////////////////
// WEBPACK FOOTER
// C:/Users/ondrej.siroky/Documents/frontend/~/core-js/library/modules/_to-object.js
// module id = 37
// module chunks = 0 1